import Button from 'elements/Button';
import ds from 'designsystem';

const DebugButton = Button.extend`
  position: relative;
  margin: 0;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, .2);
  border: none;
  color: ${ds.brand('text')};
  transition-duration: 0.2s;
  outline: none;
  background-color: ${ds.brand('white')};
  width: 133px;
  height: auto;
  white-space: nowrap;
  padding: ${ds.get('metrics.xs')} ${ds.get('metrics.s')};
  
  font-weight: ${ds.get('type.fontWeight.bold')};
  
  &:hover, &:focus {
    background-color: ${ds.brand('white')};
  }
  
  &:active {
    background-color: ${ds.brand('background')};
  }
`;

export default DebugButton;



// WEBPACK FOOTER //
// ./src/blocks/DebugComponents/DebugBar/DebugButton.jsx